// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12ZM9.5 11.5V14L14 14V16L9.5 16V18.5L5 15L9.5 11.5ZM19 9L14.5 12.5V10H10V8H14.5V5.5L19 9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-arrow-left-right-circle-filled')
export default class ArrowLeftRightCircleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'arrow-left-right-circle-filled',
    }
  }
}
